import { render, staticRenderFns } from "./DetalhesCartaModal.vue?vue&type=template&id=15ba5ed8&"
import script from "./DetalhesCartaModal.vue?vue&type=script&lang=js&"
export * from "./DetalhesCartaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports